<template>
  <section
    :id="`somnambulist-step-${stepNumber}`"
    ref="step"
    class="step"
  >
    <b-container>
      <b-row>
        <b-col>
          <step-header
            :lang-string-id="headerLangStringId"
            :number="stepNumber"
          />
        </b-col>
      </b-row>
      <component
        :is="stepComponent"
        @modalToggled="$emit('modalToggled')"
      />
    </b-container>
  </section>
</template>

<script>
import StepHeader from './StepHeader'
import OrderTypeStep from './OrderTypeStep'
import FrequencyStep from './FrequencyStep'
import QuantityStep from './QuantityStep'
import CustomStep from './CustomStep'

import VueScrollTo from 'vue-scrollto'

export default {
  name: 'step',
  components: {
    'step-header': StepHeader,
    'order-type-step': OrderTypeStep,
    'frequency-step': FrequencyStep,
    'quantity-step': QuantityStep,
    'custom-step': CustomStep
  },
  props: {
    headerLangStringId: {
      type: String,
      required: true
    },
    stepNumber: {
      type: Number,
      required: true
    },
    stepComponent: {
      type: String,
      required: true
    }
  },
  mounted() {
    if (
      !this.$store.state.somnambulistui.scrollTop &&
      !this.$store.state.somnambulistui.scrollBottom &&
      this.$store.getters['somnambulistui/getCurrentStep'] === this.stepNumber
    ) {
      VueScrollTo.scrollTo(this.$refs.step)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';

.step {
  padding:3em 0em;
  ::v-deep .club-group {
    display:flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: -1em;
    width: calc(100% + 2em);
    .club-card{
      margin:.75em;
      width:100%;
      @include media-breakpoint-up (sm) {
        width: calc((100% / 2) - 1.5em);
      }
      @include media-breakpoint-up (md) {
        width: calc((100% / 3) - 1.5em);
      }
      background: var(--main-card-background-color);
      box-shadow: var(--main-card-drop-shadow);
      border-radius: var(--main-card-border-radius);
      overflow: hidden;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      min-height:250px;
      @include transition (box-shadow .3s, transform .3s);
      &:not(.duplicate) {
        @include hover-focus {
          transform: translate(0, -10px);
          position: relative;
          z-index: 50;
        }
        &.selected {
          box-shadow: 0px 0px 0 3px var(--main-card-border-highlight-color);
        }
      }
      &.selected {
        box-shadow: 0px 0px 0 3px var(--main-card-border-highlight-color);
      }
      .club-card-content {
        padding: 1em;
        text-align: center;
        display: flex;
        flex-direction: column;
      }
      .club-card-inner {
        width: 100%;
      }
      .graphic {
        width: 100%;
        height: 8em;
        margin: 1em 0em;
        align-items: flex-end;
        align-content: center;
        display: flex;
        justify-content: center;
        position: relative;
        z-index: 1;
        .image {
          transition: all 0.3s ease;
          background-repeat: no-repeat;
          position: absolute;
          width: 8em;
          background-size: contain;
          height: 8em;
          margin-bottom: 0.5em;
          background-position: 50%;
          filter: grayscale(0.75);
        }
      }
        &.duplicate {
        cursor: not-allowed;
        @include hover-focus {
        animation: shake .82s cubic-bezier(.36,.07,.19,.97) both;
          box-shadow: 0px 0px 0 3px var(--main-danger-color);
          .club-card-image {
            filter: grayscale(100%);
          }
        }
      }
      .club-card-content {
        padding: 1em;
        text-align: center;
        display: flex;
        flex-direction: column;
        .duplicate-error {
          color: var(--main-danger-color);
        }
      }
      .club-card-image {
        height:200px;
        @include media-breakpoint-up (md) {
          height: 300px;
        }
        img {
          padding: 1em;
        }
      }
    }
  }
}

@keyframes shake {
  10%,90% {
    translub: translate3d(-1px,0,0)
  }
  20%,80% {
    transform: translate3d(2px,0,0)
  }
  30%,50%,70% {
    transform: translate3d(-4px,0,0)
  }
  40%,60% {
    transform: translate3d(4px,0,0)
  }
}
</style>
